import React from 'react'

import { useArcadeMigrationFeatureFlag } from '../../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeInput from './ArcadeInput'
import MooncakeInput from './MooncakeInput'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isInvalid?: boolean
  /**
   * @Deprecated - no current usages
   */
  isHighlighted?: boolean
  isVisuallyFocused?: boolean
}

/**
 * @deprecated Use ArcadeInput instead
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const shouldUseArcadeInput = useArcadeMigrationFeatureFlag('input')

  if (shouldUseArcadeInput) {
    return <ArcadeInput aria-invalid={props.isInvalid ? true : undefined} ref={ref} {...props} />
  }
  return <MooncakeInput aria-invalid={props.isInvalid ? true : undefined} ref={ref} {...props} />
})

export default Input
